import { createElement, memo, useMemo } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import LImage from '@max/leez-image';
import './index.scss';
import { FLIGHT_ARROW_ONEWAY_IMAGE_URL } from '../../../lib/utils/imageUtils';
const isWeb = true;
const isMRN = false;
import LinearGradient from '@hfe/max-linear-gradient';
const Recommend4 = (props) => {
    var _a, _b, _c, _d, _e;
    const week = {
        Monday: '周一',
        Tuesday: '周二',
        Wednesday: '周三',
        Thursday: '周四',
        Friday: '周五',
        Saturday: '周六',
        Sunday: '周日'
    };
    const dateFormat = useMemo(() => {
        const date = new Date(props.city.date);
        const month = date.getMonth() + 1; // 月份从0开始，所以要加1
        const day = date.getDate();
        return `${month}月${day}日`;
    }, [props.city.date]);
    const names = props.city.departCityName + props.city.arriveCityName;
    const calseFontSize = (str) => {
        if (str.length > 6) {
            return '20rpx';
        }
        return '28rpx';
    };
    const calcPaddingTop = () => {
        var _a, _b;
        if (isMRN || isWeb && !((_a = props.cornerConfig) === null || _a === void 0 ? void 0 : _a.isShowTag)) {
            return 0;
        }
        if (isWeb && ((_b = props.cornerConfig) === null || _b === void 0 ? void 0 : _b.isShowTag)) {
            return '6rpx';
        }
        return 0;
    };
    return <View className='recommend4-price-logo' onClick={() => props.jump(props.city, props.index)} style={{
        paddingBottom: '18rpx',
        paddingLeft: '18rpx',
        paddingRight: '18rpx'
    }}>
      {((_a = props.cornerConfig) === null || _a === void 0 ? void 0 : _a.isShowTag) && <LinearGradient className='recommend4-price-logo-tag' start={{
        x: 0,
        y: 0
    }} end={{
        x: 1,
        y: 1
    }} colors={[(_b = props.cornerConfig) === null || _b === void 0 ? void 0 : _b.cornerTagStartColor, (_c = props.cornerConfig) === null || _c === void 0 ? void 0 : _c.cornerTagEndColor]}>
          <View>
            <Text className="recommend4-price-logo-tag-text" style={{
        color: (_d = props.cornerConfig) === null || _d === void 0 ? void 0 : _d.cornerLabelColor,
        paddingTop: isMRN ? '4rpx' : 0
    }}>
              {(_e = props.cornerConfig) === null || _e === void 0 ? void 0 : _e.cornerLabelWord}
            </Text>
          </View>
        </LinearGradient>}

      <View className="recommend4-left-content" style={{
        paddingTop: names.length > 7 ? '32rpx' : '28rpx'
    }}>
        <View className="recommend4-city" style={{
        paddingTop: calcPaddingTop()
    }}>
          <View style={{
        maxWidth: names.length > 7 ? '84rpx' : '112rpx'
    }}>
            <Text className="recommend4-city-departCityName" style={{
        fontSize: calseFontSize(names)
    }} numberOfLines={1}>
              {props.city.departCityName}
            </Text>
          </View>
          <LImage className="recommend4-arrow" width={14} source={{
        uri: FLIGHT_ARROW_ONEWAY_IMAGE_URL
    }}></LImage>
          <View style={{
        maxWidth: names.length > 7 ? '84rpx' : '112rpx'
    }}>
            <Text className="recommend4-city-arriveCityName" style={{
        fontSize: calseFontSize(names)
    }} numberOfLines={1}>{props.city.arriveCityName}</Text>
          </View>
        </View>
        <View className="recommend4-font-grey-container" style={{
        marginTop: names.length >= 7 ? '-10rpx' : '-6rpx'
    }}>
          <Text className="recommend4-font-grey">
            {dateFormat + ' ' + week[props.city.week]}
          </Text>
        </View>
      </View>
      <View className="recommend4-right-content">
        <View className="recommend4-price">
          <Text className="recommend4-price-icon">￥</Text>
          <Text className="recommend4-price-price-number">{props.city.price}</Text>
        </View>
        <View x-if={props.city.discout > 0 && props.city.discout < 100} className="recommend4-discout-text-container">
          <Text className={'recommend4-discout-text'}>{props.city.discout > 0 ? `${props.city.discout / 10}折` : ''}
          </Text>
        </View>
      </View>
    </View>;
};
export default memo(Recommend4);
